export const GET_NEWS = 'GET_NEWS';
export const SUCCESS_GET_NEWS = 'SUCCESS_GET_NEWS';
export const FAILURE_GET_NEWS = 'FAILURE_GET_NEWS';



// WEBPACK FOOTER //
// ./js/actions/News.js